'use client';

import clsx from 'clsx';
import { useRouter } from 'next/navigation';
import { FC, useState } from 'react';

import { IconSort } from 'src/general/Icons/IconSort';
import { Shade } from 'src/general/components/Shade/Shade';
import { kebabToCamel } from 'src/plp/helpers/getPlpSlug';

import { AsxParams, AsxSortValues } from './AsxAnnouncements.types';
import { ASX_ANNOUNCEMENTS_BASE_PATH, asxSortItemsMap } from './constants';

interface Props {
  asxParams: AsxParams;
}

export const AsxAnnouncementsSort: FC<Props> = ({ asxParams = { sort: 'most-recent', page: 1 } }) => {
  const router = useRouter();
  const [value, setValue] = useState<string>(kebabToCamel(asxParams.sort ?? ''));

  const handleChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (globalThis.window !== undefined && event.target.value !== value) {
      const sortValue = event.target.value as AsxSortValues;
      const newUrl = `${ASX_ANNOUNCEMENTS_BASE_PATH}/${sortValue}`;
      setValue(event.target.value);
      router.push(newUrl);
    }
  };

  return (
    <label className="flex items-center justify-start">
      <span className="whitespace-nowrap">Sort by :&ensp;</span>
      <span className="sr-only">{value}</span>
      <span className={clsx('relative flex items-center overflow-hidden rounded-md', 'c-shade_container')}>
        <select
          className={clsx(
            'button button--small button--secondary',
            'pointer-events-auto! block py-1.5! pr-10! leading-6!',
          )}
          value={value}
          onChange={handleChangeSelect}
          data-testid="sort-trigger"
        >
          {Array.from(asxSortItemsMap.entries()).map(([key, item]) => (
            <option key={key} value={key} data-testid={`SortMenuItem-${key}`}>
              {item.label}
            </option>
          ))}
        </select>
        <Shade useParent className="pointer-events-none before:hidden" />
        <span className="relative -ml-6 h-6 w-6 -translate-x-2 text-for-pri-bas">
          <IconSort />
        </span>
      </span>
    </label>
  );
};
